import { getLocalStorage } from 'helpers/local-storage'
import { PATH_DASHBOARD } from 'routes/paths'

// Team-role-based access gating (Owner/Admin/Finance/Operations/Viewer).
// Separate from helpers/user-access — that filters by the creator account's
// feature-access whitelist, an unrelated axis from which team member is
// looking at the nav.

// Team Management's nav entry + page are restricted to these roles (FE-5 /
// TIP-21623) — Finance/Operations/Viewer can still be gated on individual
// actions via the permission matrix, but never see the section at all.
const TEAM_MANAGEMENT_ROLES = ['owner', 'admin']

export const canAccessTeamManagement = (roleName?: string): boolean =>
  TEAM_MANAGEMENT_ROLES.includes(roleName?.toLowerCase() ?? '')

interface NavItemLike {
  path?: string
}

interface NavSectionLike<T extends NavItemLike> {
  items: T[]
}

export const filterNavByTeamRole = <
  T extends NavItemLike,
  S extends NavSectionLike<T>,
>(
  menu: S[],
  hasTeamManagementAccess: boolean,
): S[] => {
  if (hasTeamManagementAccess) return menu

  return menu
    .map((main) => ({
      ...main,
      items: main.items.filter(
        (item) => item.path !== PATH_DASHBOARD.creator_center.team,
      ),
    }))
    .filter((main) => main.items.length > 0)
}

// The active organization the user is viewing. Persisted by the Organization
// store (zustand persist middleware) under this key; read it straight from
// localStorage for non-React consumers like the api-client (React code reads it
// from useActiveOrgStore instead). Keep the key in sync with the store's
// persist `name` (domains/Organization/store).
export const ACTIVE_ORG_STORAGE_KEY = 'active-org-store'

export const getActiveOrgId = (): string =>
  getLocalStorage(ACTIVE_ORG_STORAGE_KEY)?.state?.activeOrgId || ''
